import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

// sourceItems is keyed by input run asset id; inputAssets arrive ordered by position, so the
// first marketplace input wins when a run has several.
const getSourceItemUrl = ({ inputAssets = EMPTY_ARRAY, sourceItems = EMPTY_OBJECT }) => {
  const sourceAsset = inputAssets.find(({ id }) => sourceItems[id])

  return sourceAsset && sourceItems[sourceAsset.id].url
}

export default getSourceItemUrl
